<template>
  <div class="login-necker">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item, index) in data" :key="index" :to="{ path: item.to }">
        <template v-if="currentPath === item.to">
          <span :class="{ 'actived': currentPath === item.to }"> {{ item.title }} </span>
        </template>
        <template v-else>
          {{ item.title }}
        </template>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'loginNecker',
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    currentPath: {
      get() {
        return this.$route.path
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-necker {
  height: 40px;
  font-size: 14px;
  font-weight: 700;
  line-height: 40px;
  color: #303133;
  padding-left: 60px;

  .el-breadcrumb {
    line-height: 40px;
  }

  .actived {
    font-weight: 700;
    color: #178FFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/loginNecker.vue